// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:before {
  position: inherit;
  top: inherit;
  left: inherit;
  content: attr(data-date);
  display: inherit;
  color: inherit;
  margin: -5px 0px -10px 0px !important;
}

input::-webkit-datetime-edit,
input::-webkit-inner-spin-button,
input::-webkit-clear-button {
  display: none;
}

input::-webkit-calendar-picker-indicator {
  position: absolute;
  top: "%50";
  right: 10px;
  color: inherit;
  opacity: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/Components/CustomDatetime/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["input:before {\n  position: inherit;\n  top: inherit;\n  left: inherit;\n  content: attr(data-date);\n  display: inherit;\n  color: inherit;\n  margin: -5px 0px -10px 0px !important;\n}\n\ninput::-webkit-datetime-edit,\ninput::-webkit-inner-spin-button,\ninput::-webkit-clear-button {\n  display: none;\n}\n\ninput::-webkit-calendar-picker-indicator {\n  position: absolute;\n  top: \"%50\";\n  right: 10px;\n  color: inherit;\n  opacity: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
